<template>
    <tr class="text-white pb-2 h-[40px] border-b-[1px] border-[#FFF] border-opacity-10">
        <td class="w-[4%] text-start"></td>
        <td class="w-[25%] text-start"></td>
        <td class="w-[20%] text-start py-1 text-[0.9rem]">
            <div v-if="!subcategoryEdit">
                {{ subcategoryName }}
            </div>
            <input v-else v-model="subcategoryName" type="text" class="text-[0.9rem] w-[90%] bg-transparent text-[#FECC00] placeholder:text-white placeholder:text-[0.9rem] placeholder:opacity-40 relative outline-none" placeholder="Нова категорія...">
        </td>
        <td class="w-[15%] text-end text-[#BD252C] text-[0.9rem]">{{ formatNumber(subcategoryMonthSum) }}</td>
        <td class="w-[36%] h-full">
            <div class="flex justify-end items-center">
                <img v-if="!subcategoryEdit" @click="subcategoryEdit = true" src="@/assets/icons/pen_icon.svg" class="cursor-pointer mr-[10px]">
                <img v-else @click="updateSubcategory" src="@/assets/icons/green_check_point.svg" class="cursor-pointer w-[24px] h-[24px] mr-[10px]">
                <img @click="deleteSubcategory" src="@/assets/icons/trash_icon.svg" class="cursor-pointer mr-[10px]">
            </div>
        </td>
    </tr>
</template>

<script>
    import { ref, onMounted } from 'vue'

    export default {
        name: 'subcategory-element',

        props: {
            subcategoryName: {
                type: String,
                required: true
            },
            subcategoryMonthSum: {
                type: Number,
                required: true
            },
            subcategoryId: {
                type: String,
                required: true
            },
            categoryId: {
                type: String,
                required: true
            }
        },

        setup(props, { emit }) {
            const subcategoryName = ref(props.subcategoryName)
            const subcategoryEdit = ref(false)

            const formatNumber = (number) => {
                const parts = number.toFixed(2).toString().split(".");
  
                const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                
                const formattedNumber = formattedInteger + "." + parts[1];
                
                return formattedNumber;
            }

            const updateSubcategory = () => {
                emit('update-subcategory', {categoryId: props.categoryId, subcategoryId: props.subcategoryId, newName: subcategoryName.value})
                subcategoryEdit.value = false
            }

            const deleteSubcategory = () => {
                emit('delete-subcategory', props.subcategoryId)
            }

            return {
                formatNumber,
                deleteSubcategory,
                subcategoryName,
                subcategoryEdit,
                updateSubcategory
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>